import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { ShimanoTimestampedComponent } from './shimano-timestamped.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoTimestampedComponent: {
          component: ShimanoTimestampedComponent,
        },
      },
    }),
    ShimanoTimestampedComponent,
  ],
})
export class ShimanoTimestampedModule {}
